import React, { useEffect, useState } from 'react';
import UserRow from './UserRow';





const Users = () => {
     const [users, setUsers] = useState([]);

     useEffect(() => {
          fetch(`https://gentle-anchorage-39185.herokuapp.com/user`, {
               method: 'GET',
               headers: {
                    authorization: `Bearer ${localStorage.getItem('accessToken')}`
               }
          })
               .then(res => res.json())
               .then(data => setUsers(data))
     }, [])



     /*    const { data: users, isLoading } = useQuery('users', () => fetch('https://gentle-anchorage-39185.herokuapp.com/user').then(res => res.json())) */


     return (
          <div>
               <h1>Hello all Users {users.length}</h1>
               <div className="overflow-x-auto">
                    <table className="table w-full">

                         <thead>
                              <tr>
                                   <th></th>
                                   <th>Name</th>
                                   <th>Job</th>
                                   <th>Favorite Color</th>
                              </tr>
                         </thead>
                         <tbody>
                              {
                                   users.map(user => <UserRow
                                        key={user._id}
                                        user={user}
                                   ></UserRow>)
                              }


                         </tbody>
                    </table>
               </div>
          </div>
     );
};

export default Users;